import React from "react";
import { hideDialog, updateDialog } from "../../../actions/dialog";
import { freeEntities, getEntity, loadEntities, saveEntity } from "../../../actions/entities";
import { EntitiesStore } from "../../../stores/entities";
import M from "../../../strings";
import { discriminated } from "../../../utils/ajex";
import { ACTION_TYPES } from "../../components/mobile/actions";
import { isNotEmpty, isEmpty, getFileServerUrl } from "../../../framework/utils";
import { MobileDateInput, MobileSelect } from "../../components/mobile/forms";
import _ from "underscore";
import { uuid } from "../../../utils/lang";
import * as _datasource from "../../../utils/datasource";
import * as _query from "../../../framework/query";
import { getDateFromString } from "../../../utils/date";
import * as CustomUtils from "../../../utils/customUtils";

export default class StoreTrendsDownloadDialog extends React.Component {
    constructor(props) {
        super(props);
        this.discriminator = "entity_form_" + this.getEntity();
        this.formRef = React.createRef();
        this.state = {
            trendConfiguration: undefined,
            data: undefined,
        }
    }

    getEntity() {
        return "trendConfiguration"
    }

    getActions() {
        const leftHeaderActions = [
                    {
                        id: "close-mobile",
                        type: ACTION_TYPES.ICON,
                        icon: "close",
                        className: "hidden-sm-up",
                        onClick: hideDialog,
                    },
                    {
                        id: "close-tabled",
                        type: ACTION_TYPES.BUTTON,
                        text: M("cancel"),
                        className: "btn-transparent-secondary hidden-xs-down",
                        onClick: hideDialog,
                    },
                ],
            rightHeaderActions = [
                    {
                        id: "generate",
                        type: ACTION_TYPES.BUTTON,
                        text: M("create"),
                        className: "btn-transparent-primary",
                        disabled: !this.canSave(),
                        onClick: this.generateReport.bind(this),
                    }
                ];

            return {
                leftHeaderActions: leftHeaderActions,
                rightHeaderActions: rightHeaderActions,
            }
    }

    componentDidMount() {
        updateDialog(_.extend(
            {
                title: M("surveySlideshowDownloadDialogTitle"),
            },
            this.getActions(),
        ));

        EntitiesStore.subscribe(this, state => {
            const trendConfiguration = discriminated(state, this.discriminator);

            if (isNotEmpty(trendConfiguration) && isNotEmpty(trendConfiguration.data) && isEmpty(trendConfiguration.data.store)) {
                trendConfiguration.data.store = this.props.store;
            }

            this.setState({
                trendConfiguration: trendConfiguration,
                data: trendConfiguration.data,
            });
            this.forceUpdate();
        });

        getEntity({
            discriminator: this.discriminator,
            entity: this.getEntity(),
            id: "new",
        })
    }

    componentWillUnmount() {
        EntitiesStore.unsubscribe(this);
    }

    getDownloadPath() {
        return this.state.trendConfiguration?.data?.path ?? undefined;
    }

    onFormChange(data) {
        this.setState({
            data: data,
        }, () => updateDialog(this.getActions()));
    }

    canSave() {
        const data = this.state.data ?? {};
        return _.chain(data)
            .pick(
                "store",
                "surveyTemplate",
                "from",
                "to"
            )
            .values()
            .every(v => isNotEmpty(v))
            .value();
    }

    generateReport() {
        if (!this.canSave()) {
            return false;
        }

        const data = CustomUtils.deepClone(this.state.data);
        data.from = getDateFromString(data.from).toDate().getTime();
        data.to = getDateFromString(data.to).toDate().getTime();

        saveEntity({
            discriminator: this.discriminator,
            entity: this.getEntity(),
            data: data,
            reload: true,
        }).then(() => updateDialog({
                leftHeaderActions: [
                    {
                        id: "close-mobile",
                        type: ACTION_TYPES.ICON,
                        icon: "close",
                        className: "hidden-sm-up",
                        onClick: hideDialog,
                    },
                    {
                        id: "close-tabled",
                        type: ACTION_TYPES.BUTTON,
                        text: M("close"),
                        className: "btn-transparent-secondary hidden-xs-down",
                        onClick: hideDialog,
                    },
                ],
                rightHeaderActions: [],
            })); 
    }

    downloadReport() {
        const path = this.getDownloadPath();
        if (isNotEmpty(path)) {
            window.open(getFileServerUrl(path));
        }
    }

    render() {
        const data = this.state.data,
            downloadPath = this.getDownloadPath();

        return(
            <>
                {isNotEmpty(data) && <>
                    {isEmpty(downloadPath) ? (
                        <div
                            className="m-3"
                        >
                            <TrendConfigurationForm
                                ref={this.formRef}
                                data={data}
                                onChange={this.onFormChange.bind(this)}
                            />
                        </div>
                    ) : (
                        <div
                            className="m-5 text-center"
                        >
                            <div
                                className="mb-3"
                            >
                                {M("storeTrendsDownloadSuccessMessate")}
                            </div>
                            <button
                                className="btn btn-primary font-weight-bold"
                                role="button"
                                onClick={this.downloadReport.bind(this)}
                            >
                                {M("download")}
                            </button>
                        </div>
                    )}
                </>}
            </>
        )
    }
}

class TrendConfigurationForm extends React.Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef()
        this.discriminator = uuid();
        this.datasource = _datasource.create();
    }

    componentDidMount() {
        EntitiesStore.subscribe(this, state => {
            const result = discriminated(state, this.discriminator)?.result ?? {};
            this.setState({
                result: result,
            }, this.updateDatasource.bind(this));
        })
        loadEntities({
            discriminator: this.discriminator,
            entity: "surveyTemplate",
            query: _query.create({
                    rowsPerPage: 0,
                }),
        })
    }

    updateDatasource() {
        const rows = this.state.result?.rows,
            data = _.map(rows, row => {
                return {
                    value: row.id,
                    label: row.description,
                }
            });

        this.datasource.setData(data);
    }

    componentWillUnmount() {
        EntitiesStore.unsubscribe(this);
        freeEntities({
            discriminator: this.discriminator
        });
    }

    onChange(e) {
        const data = this.getData();
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            this.props.onChange(data);
        }
    }

    getData() {
        const $form = $(this.formRef.current),
            data = _.chain($form.serializeArray())
                .map(i => [i.name, i.value])
                .object()
                .value();

        data.surveyTemplate = _.findWhere(this.state.result?.rows ?? [], {id: data.surveyTemplateId});
        data.store = this.props.data.store;

        return data;
    }

    onSubmit(e) {
        e && e.preventDefault();
        if (this.props.onSubmit && _.isFunction(this.props.onSubmit)) {
            this.props.onSubmit(e);
        }
    }

    render() {
        const data = this.props.data ?? {},
            {surveyTemplateId, from, to} = data;

        return(
            <form
                ref={this.formRef}
                action=""
                onSubmit={this.onSubmit.bind(this)}
            >
                <MobileSelect
                    label={M("surveyTemplate")}
                    value={surveyTemplateId}
                    name="surveyTemplateId"
                    datasource={this.datasource}
                    onChange={this.onChange.bind(this)}
                />
                <MobileDateInput
                    label={M("from")}
                    value={from}
                    placeholder={M("from")}
                    name="from"
                    onChange={this.onChange.bind(this)}
                />
                <MobileDateInput
                    label={M("to")}
                    value={to}
                    placeholder={M("to")}
                    name="to"
                    onChange={this.onChange.bind(this)}
                />
            </form>
        )
    }
}